import { gql } from '@apollo/client'

export const SelectedQuery = gql`
  query SelectedCustomFieldSelector($companyId: ID!, $id: ID) {
    customFields(companyId: $companyId, filters: { idEq: $id }) {
      nodes {
        id
        name
      }
    }
  }
`

export const Query = gql`
  query CustomFieldSelector(
    $companyId: ID!,
    $filters: CustomFieldFilters,
    $after: String,
    $before: String,
    $first: Int,
    $last: Int
  ) {
    customFields(companyId: $companyId, filters: $filters, after: $after, before: $before, first: $first, last: $last) {
      nodes {
        id
        name
      }
      pageInfo { startCursor endCursor hasNextPage hasPreviousPage }
    }
  }
`
